export const SHOW_LOADER = "SHOW_LOADER";
export const HIDEN_LOADER = "HIDEN_LOADER";